export default __webpack_public_path__ + "media/images/amenities/laundry-e510e2a9c09d7e5f9d8eb919c6f469ba.jpeg";